import { render, staticRenderFns } from "./TagSelectOption.vue?vue&type=template&id=71253f5c&scoped=true"
import script from "./TagSelectOption.vue?vue&type=script&lang=js"
export * from "./TagSelectOption.vue?vue&type=script&lang=js"
import style0 from "./TagSelectOption.vue?vue&type=style&index=0&id=71253f5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71253f5c",
  null
  
)

export default component.exports